import styled from 'styled-components';

export const Mark = styled.span`
  display: inline-block;
  position: relative;
  border-radius: 4px;
  left: 0;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
    transform: translate(-50%, -50%);
  }
`;

export const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;

  & + ${Mark} {
    border: 2px solid ${(props: any) => props.theme.colors[props['data-color']]};

    ${(props: any) => {
      switch (props['data-size']) {
        case 'small':
          return `
            width: 16px;
            height: 16px;
          `;

        default:
        case 'medium':
          return `
            width: 18px;
            height: 18px;
          `;

        case 'large':
          return `
            width: 20px;
            height: 20px;
          `;
      }
    }};
  }

  &:checked + ${Mark} {
    border-color: ${(props: any) => props.theme.colors[props['data-coloractive']]};

    &::after {
      opacity: 1;
      border-radius: 2px;
      background-color: ${(props: any) => props.theme.colors[props['data-coloractive']]};

      ${(props: any) => {
        switch (props['data-size']) {
          case 'small':
            return `
              width: 8px;
              height: 8px;
            `;

          default:
          case 'medium':
            return `
              width: 10px;
              height: 10px;
            `;

          case 'large':
            return `
              width: 12px;
              height: 12px;
            `;
        }
      }};
    }
  }
`;

export const Wrapper = styled.label`
  display: flex;
  cursor: pointer;
`;
